import { homeNavCollapsed } from "@clockwise/web-commons/src/util/local-storage";
import React, { ReactNode } from "react";
import { TrackingEvents, track } from "../../util/analytics.util";
import { tailwindScreenSize } from "../../util/tailwindValues";
import { TEMP_FOUND_AppLayout } from "../app-layout/AppLayout";

type Props = {
  secondary?: ReactNode;
  data?: {
    withToolbar?: boolean;
    collapsedSidebar?: boolean;
  };
  banner?: ReactNode;
  collapsedSidebar?: boolean;
};

// TODO: @scott refactor to util
export const determineCollapseDefault = (userId?: string | null) => {
  if (homeNavCollapsed.isNull()) {
    const screenSize = window.innerWidth;
    const smallScreen = tailwindScreenSize("sm");

    if (!smallScreen) {
      userId &&
        track(TrackingEvents.WEB_LAYOUT.COLLAPSE_EXPAND.NO_DEFINITION_OF_SMALL_SCREEN, {
          userId: userId,
        });
      return false;
    }

    if (screenSize <= smallScreen) {
      userId &&
        track(TrackingEvents.WEB_LAYOUT.COLLAPSE_EXPAND.SMALL_SCREEN_DEFAULT, {
          userId: userId,
        });
      return true;
    }

    userId &&
      track(TrackingEvents.WEB_LAYOUT.COLLAPSE_EXPAND.BIG_SCREEN_DEFAULT, {
        userId: userId,
      });
    return false;
  }

  return homeNavCollapsed.get();
};
/**
 * @deprecated use AppLayout
 */
const ClockwiseWebLayout: React.FC<React.PropsWithChildren<Props>> = (props) => {
  return <TEMP_FOUND_AppLayout>{props.children}</TEMP_FOUND_AppLayout>;
};

export default ClockwiseWebLayout;
